import React, { useState, useEffect } from "react";
import { database } from "../firebaseConfig";
import { onValue, ref } from "firebase/database";

export default function CheckoutCounter() {
  const [deaths, setDeaths] = useState(0);
  const [escapes, setEscapes] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    // Clean up event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const Spinner = () => {
    const staticChars = ["▒", "░"];
    const [char, setChar] = useState(staticChars[0]);

    useEffect(() => {
      const interval = setInterval(() => {
        // Pick a random character from the staticChars array
        const randomChar =
          staticChars[Math.floor(Math.random() * staticChars.length)];
        setChar(randomChar);
      }, 120); // update every 100ms
      return () => clearInterval(interval);
    }, []);

    return <span>{char}</span>;
  };

  useEffect(() => {
    // Create references to your global totals
    const deathsRef = ref(database, "globalGameStats/deaths");
    const escapesRef = ref(database, "globalGameStats/escapes");

    // Set up listeners for changes
    const unsubscribeDeaths = onValue(deathsRef, (snapshot) => {
      setDeaths(snapshot.val() || 0);
    });
    const unsubscribeEscapes = onValue(escapesRef, (snapshot) => {
      setEscapes(snapshot.val() || 0);
    });

    // Clean up the listeners on unmount
    return () => {
      unsubscribeDeaths();
      unsubscribeEscapes();
    };
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        backgroundColor: "rgb(150, 167, 168)",
        justifyContent: "center",
        alignItems: "center",
        width: "89.7%",
        color: "black",
        padding: "5px",
      }}
    >
      <div
        style={{
          display: "flex",
          width: isMobile ? "100%" : "50%",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          textAlign: "center",
        }}
      >
        <Spinner />
        <Spinner />
        <Spinner />
        <div style={{ fontStyle: "italic", fontWeight: 600, fontSize: "20px" }}>
          Check-out counter
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginLeft: "15px",
          }}
        >
          <div style={{ marginRight: "15px", marginLeft: "15px" }}>Normal:</div>
          {escapes}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ marginRight: "15px", marginLeft: "15px" }}>Corpse:</div>
          {deaths}
        </div>
        <Spinner />
        <Spinner />
        <Spinner />
      </div>
    </div>
  );
}
